/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
// material
import { Divider, List, ListItemButton, Stack, Tooltip, Typography } from '@mui/material';

import { useSelector } from 'react-redux';
import moment from 'moment';
import { Fragment } from 'react';
import { calculNbG, speedConverter } from '../../common/utils/unitConverter';
import { useTranslation } from '../../common/LocalizationProvider';
import { selectSession } from '../../createSelectorUtils';

// ----------------------------------------------------------------------

function colorAtterrissage(analyseToucher) {
  if (analyseToucher === -1) {
    return 'violet';
  }
  if (analyseToucher <= 20 && analyseToucher >= 0) {
    return 'green';
  }
  if (analyseToucher > 40) {
    return 'red';
  }
  return 'orange';
}

// ----------------------------------------------------------------------

FlightReviewLanding.propTypes = {
  positions: PropTypes.array,
  analyse: PropTypes.object,
  state: PropTypes.object,
  setState: PropTypes.func,
  device: PropTypes.object
};

export default function FlightReviewLanding({ analyse, positions, state, setState, device }) {
  const t = useTranslation();
  const session = useSelector(selectSession);

  const messageAtterrissage = (analyseToucher) => {
    if (analyseToucher === -1) return t('FR_Phases_TooEarly');
    if (analyseToucher <= 20 && analyseToucher >= 0) return t('FR_Phases_VeryGood');
    if (analyseToucher > 40) return t('FR_Phases_TooLong');
    return t('FR_Phases_QuiteWell');
  };

  return (
    <List>
      {analyse.analyseAtterrissageReports.map((atterrissage, index) => (
        <Fragment key={index}>
          <Tooltip
            title={
              <Stack direction="column">
                <Typography variant="body2">
                  {messageAtterrissage(atterrissage.analyseToucher)}
                </Typography>
                <Typography variant="body2">{t('FR_Phases_Landing_Distance_Info')}</Typography>
              </Stack>
            }
            placement="top"
          >
            <ListItemButton
              selected={state.selectedListItem === index}
              onClick={() =>
                setState({
                  ...state,
                  selectedListItem: index,
                  currentPosition: positions.indexOf(
                    positions.find((item) => item.id === atterrissage.pointPositionId)
                  )
                })
              }
              key={`info-${index}`}
              sx={{
                color: colorAtterrissage(atterrissage.analyseToucher)
              }}
            >
              <Stack direction="column" key={`stackInfo-${index}`}>
                <Typography variant="subtile1">{`n° ${index + 1} - ${moment(
                  positions.find((item) => item.id === atterrissage.pointPositionId).fixTime
                ).format('HH:mm:ss')} ${t('words_On')} ${atterrissage.oaci}`}</Typography>
                {atterrissage.distance > 0 && (
                  <Typography variant="subtitle1">
                    {`${t('DB_Distance_Landing')}: ${atterrissage.distance.toFixed(0)} m`}
                  </Typography>
                )}
              </Stack>
            </ListItemButton>
          </Tooltip>
          {atterrissage.speedAlert || atterrissage.speedWarning ? (
            <Tooltip
              title={` ${t('FR_Phases_VitesseMin')}: ${speedConverter(
                atterrissage.speedAlert && atterrissage.speedMaxAtterrissageAlert
                  ? atterrissage.speedMaxAtterrissageAlert
                  : device.speedMaxAtterrissageWarning,
                session.uniteVitesse
              )} ${session.uniteVitesse}`}
              placement="top"
              key={`speed-${index}`}
            >
              <ListItemButton
                selected={state.selectedListItem === index}
                onClick={() =>
                  setState({
                    ...state,
                    selectedListItem: index,
                    currentPosition: atterrissage.speedAlert
                      ? positions.indexOf(
                          positions.find((item) => item.id === atterrissage.speedAlert)
                        )
                      : positions.indexOf(
                          positions.find((item) => item.id === atterrissage.speedWarning)
                        )
                  })
                }
              >
                {atterrissage.speedAlert ? (
                  <Typography variant="subtitle1" style={{ color: '#bb0b0b' }}>
                    {`${t('DB_SpeedAlert')}:: ${speedConverter(
                      positions.find((position) => position.id === atterrissage.speedAlert).speed,
                      session.uniteVitesse
                    )} ${session.uniteVitesse}`}
                  </Typography>
                ) : (
                  <Typography variant="subtitle1" style={{ color: '#FF9966' }}>
                    {`${t('DB_SpeedWarning')}: ${speedConverter(
                      positions.find((position) => position.id === atterrissage.speedWarning).speed,
                      session.uniteVitesse
                    )} ${session.uniteVitesse}`}
                  </Typography>
                )}
              </ListItemButton>
            </Tooltip>
          ) : null}
          {atterrissage.gAlert || atterrissage.gWarning ? (
            <Tooltip
              title={`${t('FR_Phases_NombreG')}: ${
                atterrissage.gAlert ? device.gAtterrissageMinAlert : device.gAtterrissageMinWarning
              } G`}
              placement="top"
              key={`g-${index}`}
            >
              <ListItemButton
                selected={state.selectedListItem === index}
                onClick={() =>
                  setState({
                    ...state,
                    selectedListItem: index,
                    currentPosition: atterrissage.gAlert
                      ? positions.indexOf(positions.find((item) => item.id === atterrissage.gAlert))
                      : positions.indexOf(
                          positions.find((item) => item.id === atterrissage.gWarning)
                        )
                  })
                }
              >
                {atterrissage.gAlert ? (
                  <Typography variant="subtitle1" style={{ color: '#bb0b0b' }}>
                    {`${t('DB_GAlert')}: ${calculNbG(
                      positions.find((position) => position.id === atterrissage.gAlert)
                    )}`}
                  </Typography>
                ) : (
                  <Typography variant="subtitle1" style={{ color: '#FF9966' }}>
                    {`${t('DB_GWarning')}: ${calculNbG(
                      positions.find((position) => position.id === atterrissage.gWarning)
                    )}`}
                  </Typography>
                )}
              </ListItemButton>
            </Tooltip>
          ) : null}
          <Divider />
        </Fragment>
      ))}
    </List>
  );
}
